import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  required: {
    id: 'd/qpWD',
    defaultMessage: '(required)',
    description: 'Annotation text for template attributes that are required',
  },
  barcodeInfoTooltip: {
    id: 'KkhrIG',
    defaultMessage: 'Includes UPC, ISBN, GTIN, and other barcode formats.',
    description: 'Tooltip explaining the Barcode field accepts multiple barcode formats',
  },
});
